import { TunaDialog, DialogContent, DialogActions } from '../primitives/dialog.js'
import { Button } from '../primitives/button.js'
import type { FC, MouseEvent } from 'react'
import React from 'react'
import { DialogTitle } from './dialog-title.js'

export interface CDialogProps {
  className?: string
  open: boolean
  controls?: React.ReactNode
  showClose?: boolean
  closeText?: string
  title?: string
  showOK?: boolean
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
  fullWidth?: boolean
  fullScreen?: boolean
  children?: React.ReactNode
  style?: React.CSSProperties
  onClick?: (ev: MouseEvent) => void
  onClose(ev?: MouseEvent): void
  onOK?(ev: MouseEvent): void
}

export const Dialog: FC<CDialogProps> = ({
  className,
  children,
  open,
  controls = null,
  onClose,
  closeText = 'Close',
  title,
  showClose = false,
  showOK = false,
  onOK,
  maxWidth,
  fullWidth,
  fullScreen,
  style,
  onClick,
}) => {
  if (!open) {
    return null
  }

  const showActions = showOK || showClose

  return (
    <TunaDialog
      open={open}
      className={className}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullScreen={fullScreen}
      style={style}
    >
      {title ? (
        <DialogTitle onClose={onClose} id="alert-dialog-title" controls={controls}>
          {title}
        </DialogTitle>
      ) : null}
      <DialogContent
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '16px',
        }}
        onClick={onClick}
      >
        {children}
      </DialogContent>
      {showActions ? (
        <DialogActions>
          {showOK && <Button onClick={onOK}>OK</Button>}
          {showClose && <Button onClick={onClose}>{closeText}</Button>}
        </DialogActions>
      ) : null}
    </TunaDialog>
  )
}

export default Dialog
